import { render } from "./assets.vue?vue&type=template&id=f5df3584"
import script from "./assets.vue?vue&type=script&lang=js"
export * from "./assets.vue?vue&type=script&lang=js"
script.render = render

export default script